import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// All TMDB calls go through our Django proxy (/api/v1/tmdb/) so the TMDB API
// keys live server-side instead of being inlined into the shipped JS bundle.
// Responses are passed through verbatim, so shapes (results/cast/crew) are
// unchanged from the previous direct-to-TMDB implementation.
const proxyPath = (path, params = {}) => {
  const search = new URLSearchParams({ path, ...params });
  return `/api/v1/tmdb/?${search.toString()}`;
};

export const tmdbApi = createApi({
  reducerPath: 'tmdbApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
  }),
  endpoints: (builder) => ({
    searchMoviesAndShows: builder.query({
      query: (query) => proxyPath('search/multi', { query }),
      providesTags: ['MoviesAndShows'],
    }),
    getRecommendations: builder.query({
      query: ({ mid, tid }) => {
        const type = mid ? 'movie' : 'tv';
        const id = mid || tid;
        return proxyPath(`${type}/${id}/recommendations`);
      },
      providesTags: ['recommendations'],
    }),

    searchPerson: builder.query({
      query: (query) => proxyPath('search/person', { query }),
      providesTags: ['person'],
    }),
    getPopularMovies: builder.query({
      query: () => proxyPath('movie/popular', { language: 'en-US', page: '1' }),
      providesTags: ['popularMovies'],
    }),
    getTopTv: builder.query({
      // Trending series this week — curated "top picks", with real TMDB tv ids.
      query: () => proxyPath('trending/tv/week'),
      providesTags: ['topTv'],
    }),
    searchPersonId: builder.query({
      query: (pid) => proxyPath(`person/${pid}/combined_credits`, { language: 'en-US' }),
      providesTags: ['personId'],
    }),
    searchCredits: builder.query({
      query: ({ mid, tid }) => {
        const type = mid ? 'movie' : 'tv';
        const id = mid || tid;
        return proxyPath(`${type}/${id}/credits`, { language: 'en-US' });
      },
    }),
  }),
});

// Export the lazy hook
export const { useLazySearchMoviesAndShowsQuery,useSearchPersonQuery,useLazySearchPersonIdQuery,useGetRecommendationsQuery ,useGetPopularMoviesQuery,useGetTopTvQuery,useSearchMoviesAndShowsQuery,useSearchCreditsQuery} = tmdbApi;
